<template>
  <div>
    <filters
      :add="false"
      :search="false"
      :year-charts="true"
      @filtered-items="filter"
    />
    <!-- <b-col class="col-lg-4 col-md-4 col-12">
        <b-card>
          <IEcharts
            :option="option"
            ref="gauge"
            :resizable="true"
            class="echarts"
          />
        </b-card>
      </b-col> -->
    <b-row>
      <b-col>
        <b-card>
          <h3>{{ $t('finance.income') }}</h3>
          <app-echart-bar
            v-if="chart"
            ref="bar"
            :option-data="optionBar2"
            :resizable="true"
            class="echarts"
          />
          <!-- <IEcharts

            ref="gauge"
            :option="optionBar"
            :resizable="true"
            class="echarts min-height"
          /> -->
        </b-card>
      </b-col>
    </b-row>

    <!-- <hr class="hr__style"> -->
  </div>
</template>

<script>
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
import { BCard, BRow, BCol } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import filters from '@/components/filters.vue'

export default {
  name: 'CashFlow',
  components: {
    BRow,
    BCol,
    BCard,
    AppEchartBar,
    filters,
  },
  data() {
    return {
      chart: true,
      params: {
        year: null,
      },
      optionBar2: {
        legend: {},      
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      },








      optionBar: {
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [],
      },
    }
  },

  computed: {
    ...mapGetters('finance', ['GET_TRANSACTIONS_INCOME_CHARTS']),
  },
  watch: {
    '$i18n.locale': function () {
      setTimeout(() => {
        this.refresh()
      }, 500)
    },
  },

  mounted() {
    this.params.year = new Date().getFullYear()
    this.refresh()
  },

  methods: {
    ...mapActions('finance', ['FETCH_TRANSACTION_INCOME_CHARTS']),

    filter(val) {
      const date = new Date(val.year).toISOString().split('-')[0]
      if (!val.year) {
        this.params.year = new Date().getFullYear()
      } else {
        this.params.year = date
      }
      this.refresh()
    },

    refresh() {
      this.chart = false
      this.FETCH_TRANSACTION_INCOME_CHARTS(this.params)
        .then(r => {
          let colors = [  '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42']
          this.optionBar2.xAxis = {
            type: 'category',
            data: r.labels,
          }
          console.log(r.series.length)
          r.series.forEach((elem, index) => {
            elem.type = 'bar'
            elem.stack = 'others'

            if(elem.name == 'Total'){
              elem.stack = 'total'
            }
            elem.color = colors[index]


          })
          this.optionBar2.series = r.series
          this.chart = true
        })
    },
  },
}
</script>

<style>
  .echarts {
  width: 100%;
  min-height: 700px;
}

.hr__style {
  border-bottom: 2px solid #ebe9f1;
  margin-bottom: 35px
}
</style>
